export default __webpack_public_path__ + "static/media/report_recl.1a4a0848.svg";